import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "purchase-amount" }
const _hoisted_3 = {
  key: 0,
  class: "purchase-bonus"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "purchase-pack-wrapper",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectProduct && _ctx.selectProduct(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["top-wrapper", { most_popular: _ctx.reference === 'most_popular', best_value: _ctx.reference === 'best_value' }])
    }, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t(`purchasePacks.reference.${_ctx.reference}`)), 1)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["body-wrapper", { highlighted: _ctx.highlighted }])
    }, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.amount), 1),
      (_ctx.extra)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "+" + _toDisplayString(_ctx.extra) + " " + _toDisplayString(_ctx.$t('rateFinder.free')), 1))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}